import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Switch } from '@/components/ui/switch'
import { AgentService } from '@/services/agent.service'
import { IconEdit, IconTrash } from '@tabler/icons-react'
import { Link } from '@tanstack/react-router'
import { type ColumnDef } from '@tanstack/react-table'
import { useAgents } from '../context/agents-context'
import { type Agent } from '../adapters/agent-api-adapter'

export const columns: ColumnDef<Agent>[] = [
  {
    accessorKey: 'name',
    header: 'Nome',
    cell: ({ row }) => (
      <div className='flex items-center gap-2'>
        <span className='font-medium'>{row.original.name}</span>
      </div>
    ),
  },
  {
    accessorKey: 'model',
    header: 'Modelo',
    cell: ({ row }) => (
      <Badge variant='outline'>
        {row.original.model === 'gpt-4o' ? 'GPT-4o' : 'GPT-4o Mini'}
      </Badge>
    ),
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => (
      <Badge
        variant={row.original.status === 'active' ? 'default' : 'secondary'}
      >
        {row.original.status === 'active' ? 'Ativo' : 'Inativo'}
      </Badge>
    ),
  },
  {
    accessorKey: 'isDefault',
    header: 'Padrão',
    cell: ({ row }) => {
      const { refetch } = useAgents()
      return (
        <Switch
          checked={row.original.isDefault}
          onCheckedChange={async (checked) => {
            try {
              await AgentService.setDefault(row.original.id, checked)
              refetch()
            } catch (error) {
              console.error('Failed to set default agent:', error)
            }
          }}
        />
      )
    },
  },
  {
    accessorKey: 'language',
    header: 'Idioma',
    cell: ({ row }) => <span>{row.original.language}</span>,
  },
  {
    accessorKey: 'messageCount',
    header: 'Mensagens',
    cell: ({ row }) => (
      <span className='text-muted-foreground'>
        {row.original.messageCount.toLocaleString()}
      </span>
    ),
  },
  {
    accessorKey: 'createdAt',
    header: 'Criado em',
    cell: ({ row }) => {
      const date = new Date(row.original.createdAt)
      return (
        <span className='text-muted-foreground'>
          {date.toLocaleDateString('pt-BR')}
        </span>
      )
    },
  },
  {
    id: 'actions',
    cell: ({ row }) => {
      const { setOpen, setCurrentRow } = useAgents()

      return (
        <div className='flex items-center gap-2'>
          <Link to='/agents/$id/edit' params={{ id: String(row.original.id) }}>
            <Button variant='ghost' size='icon'>
              <IconEdit className='h-4 w-4' />
            </Button>
          </Link>
          <Button
            variant='ghost'
            size='icon'
            onClick={() => {
              setCurrentRow({
                id: row.original.id,
                name: row.original.name,
                model: row.original.model,
                status: row.original.status,
                language: row.original.language,
                messageCount: row.original.messageCount,
                createdAt: row.original.createdAt,
              })
              setOpen('delete')
            }}
          >
            <IconTrash className='h-4 w-4 text-destructive' />
          </Button>
        </div>
      )
    },
  },
]
